var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmClusterMapLM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-cluster-map-dm-cls-1 {\n        fill: #c1c1c1;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-1, .dummy-widget-cluster-map-dm-cls-2, .dummy-widget-cluster-map-dm-cls-3, .dummy-widget-cluster-map-dm-cls-4, .dummy-widget-cluster-map-dm-cls-5, .dummy-widget-cluster-map-dm-cls-6, .dummy-widget-cluster-map-dm-cls-7, .dummy-widget-cluster-map-dm-cls-8, .dummy-widget-cluster-map-dm-cls-9, .dummy-widget-cluster-map-dm-cls-10 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-11 {\n        clip-path: url(#dummy-widget-cluster-map-dm-clippath);\n      }\n\n      .dummy-widget-cluster-map-dm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-3 {\n        fill: #4f7cbd;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-4 {\n        fill: #e9e9ea;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-5 {\n        isolation: isolate;\n        opacity: .5;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-5, .dummy-widget-cluster-map-dm-cls-8 {\n        fill: #fff;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-6 {\n        fill: #ea6a6a;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-7 {\n        fill: #f4f3f3;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-9 {\n        fill: #dadada;\n      }\n\n      .dummy-widget-cluster-map-dm-cls-10 {\n        fill: #9870ae;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-cluster-map-dm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-2",
    x: 7.2,
    y: 7.2,
    width: 155.5,
    height: 154
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-4",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-cluster-map-dm-cls-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-cluster-map-dm-cls-5",
    d: "M13.5-81.9h142.9c3.5,0,6.3,2.8,6.3,6.2V14.4c0,3.4-2.8,6.2-6.3,6.2H13.5c-3.5,0-6.3-2.8-6.3-6.2v-90.1c0-3.4,2.8-6.2,6.3-6.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-5",
    x: 7.2,
    y: 149.3,
    width: 155.5,
    height: 102.5,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 7.4,
    y: 33.5,
    width: 155,
    height: 102.6,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-cluster-map-dm-cls-1",
    d: "M155.6,136.4H14.3c-3.9,0-7.1-3.2-7.1-7.1V40.4c0-3.9,3.2-7.1,7.1-7.1h141.3c3.9,0,7.1,3.2,7.1,7.1v88.9c0,3.9-3.2,7.1-7.1,7.1ZM14.3,33.7c-3.7,0-6.7,3-6.7,6.7v88.9c0,3.7,3,6.7,6.7,6.7h141.3c3.7,0,6.7-3,6.7-6.7V40.4c0-3.7-3-6.7-6.7-6.7H14.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-cluster-map-dm-cls-7",
    d: "M21.6,41.3h127.6c3.4,0,6.2,2.8,6.2,6.2v74.5c0,3.4-2.8,6.2-6.2,6.2H21.6c-3.4,0-6.2-2.8-6.2-6.2V47.5c0-3.4,2.8-6.2,6.2-6.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-9",
    x: 15.4,
    y: 96.9,
    width: 139.9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 26.9,
    y: 41.3,
    width: 5.5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 55.9,
    y: 41.3,
    width: 5.5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 70.9,
    y: 41.3,
    width: 5.5,
    height: 32.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 100.5,
    y: 111.3,
    width: 5.5,
    height: 16.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 128.5,
    y: 41.3,
    width: 5.5,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 56.7,
    y: 70.2,
    width: 34.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 27.2,
    y: 111.3,
    width: 34.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 84.9,
    y: 41.3,
    width: 5.5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 114,
    y: 41.3,
    width: 5.5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 143.1,
    y: 41.3,
    width: 5.5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 26.9,
    y: 104.1,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 55.9,
    y: 104.1,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 84.9,
    y: 104.1,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 114,
    y: 104.1,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-dm-cls-8",
    x: 143.3,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-dm-cls-6",
    cx: 62.9,
    cy: 100.3,
    rx: 9.5,
    ry: 9.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-dm-cls-10",
    cx: 121.4,
    cy: 88.2,
    rx: 6.8,
    ry: 6.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-dm-cls-3",
    cx: 85.4,
    cy: 68.5,
    rx: 3.8,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-dm-cls-3",
    cx: 26.2,
    cy: 75.9,
    rx: 5,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-dm-cls-3",
    cx: 93,
    cy: 104.1,
    rx: 3.8,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-dm-cls-3",
    cx: 149.5,
    cy: 94.9,
    rx: 2.8,
    ry: 2.8
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmClusterMapLM);
export default __webpack_public_path__ + "static/media/dm_cluster_map_l-m.dcfcda20.svg";
export { ForwardRef as ReactComponent };